import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react'

import { cn } from '@gto/ui/cn'

import { groupedFieldVariants } from './grouped-field.styles'

export type GroupedFieldErrorProps = ComponentPropsWithoutRef<'p'> & {
  /** Error text for the grouped controls. */
  children?: ReactNode
  /** Additional CSS class names. */
  className?: string
  /** React 19 ref prop. */
  ref?: Ref<HTMLParagraphElement>
}

export const Error = ({ className, ref, ...props }: GroupedFieldErrorProps) => {
  const { error } = groupedFieldVariants()

  return (
    <p
      ref={ref}
      className={cn(error(), className)}
      role="alert"
      {...props}
    />
  )
}
